import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import {ClearSlots as $62024859ff9f1f8a$export$ceb145244332b7a2, SlotProvider as $62024859ff9f1f8a$export$8107b24b91795686} from "../utils/Slots.mjs";
import {Grid as $572f9fec526c2697$export$ef2184bd89960b14} from "../layout/Grid.mjs";
import $jp9jM$intlStringsmjs from "./intlStrings.mjs";
import "../menu_vars.css";
import $jp9jM$menu_vars_cssmjs from "../menu_vars_css.mjs";
import {Text as $f8cc90fea9436c19$export$5f1af8db9871e1d6} from "../text/Text.mjs";
import {useMenuContext as $9f4d05c8f96993f7$export$21c7ab35b39f78ec, useSubmenuTriggerContext as $9f4d05c8f96993f7$export$dc2161044aa0b36d} from "./context.mjs";
import $jp9jM$spectrumiconsuiCheckmarkMedium from "@spectrum-icons/ui/CheckmarkMedium";
import $jp9jM$spectrumiconsworkflowChevronLeft from "@spectrum-icons/workflow/ChevronLeft";
import $jp9jM$spectrumiconsworkflowChevronRight from "@spectrum-icons/workflow/ChevronRight";
import {FocusRing as $jp9jM$FocusRing} from "react-aria/FocusRing";
import $jp9jM$spectrumiconsworkflowInfoOutline from "@spectrum-icons/workflow/InfoOutline";
import {mergeRefs as $jp9jM$mergeRefs} from "react-aria/mergeRefs";
import $jp9jM$react, {useRef as $jp9jM$useRef, useMemo as $jp9jM$useMemo} from "react";
import {useLocale as $jp9jM$useLocale} from "react-aria/I18nProvider";
import {useLocalizedStringFormatter as $jp9jM$useLocalizedStringFormatter} from "react-aria/useLocalizedStringFormatter";
import {useMenuItem as $jp9jM$useMenuItem} from "react-aria/useMenu";
import {useObjectRef as $jp9jM$useObjectRef} from "react-aria/useObjectRef";
import {useSlotId as $jp9jM$useSlotId} from "react-aria/private/utils/useId";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


















function $764fca59ff9a0c0a$export$2ce376c2cc3355c8(props) {
    let { item: item, state: state, isVirtualized: isVirtualized } = props;
    let { closeOnSelect: closeOnSelect } = (0, $9f4d05c8f96993f7$export$21c7ab35b39f78ec)();
    let { rendered: rendered, key: key } = item;
    let stringFormatter = (0, $jp9jM$useLocalizedStringFormatter)((0, ($parcel$interopDefault($jp9jM$intlStringsmjs))), '@react-spectrum/menu');
    let { direction: direction } = (0, $jp9jM$useLocale)();
    let submenuTriggerContext = (0, $9f4d05c8f96993f7$export$dc2161044aa0b36d)();
    let { triggerRef: triggerRef, ...submenuTriggerProps } = submenuTriggerContext || {};
    let isSubmenuTrigger = !!submenuTriggerContext;
    let isUnavailable;
    let ElementType = item.props.href ? 'a' : 'div';
    if (isSubmenuTrigger) isUnavailable = submenuTriggerContext.isUnavailable;
    let isDisabled = state.disabledKeys.has(key);
    let isContextualHelpTrigger = isSubmenuTrigger && isUnavailable !== undefined;
    let isSelectable = (isContextualHelpTrigger ? !isUnavailable : !isSubmenuTrigger) && state.selectionManager.selectionMode !== 'none';
    let isSelected = isSelectable && state.selectionManager.isSelected(key);
    let itemref = (0, $jp9jM$useRef)(null);
    let ref = (0, $jp9jM$useObjectRef)((0, $jp9jM$useMemo)(()=>(0, $jp9jM$mergeRefs)(itemref, triggerRef), [
        itemref,
        triggerRef
    ]));
    let { menuItemProps: menuItemProps, labelProps: labelProps, descriptionProps: descriptionProps, keyboardShortcutProps: keyboardShortcutProps } = (0, $jp9jM$useMenuItem)({
        isSelected: isSelected,
        isDisabled: isDisabled,
        'aria-label': item['aria-label'],
        key: key,
        closeOnSelect: closeOnSelect,
        isVirtualized: isVirtualized,
        ...submenuTriggerProps
    }, state, ref);
    let endId = (0, $jp9jM$useSlotId)();
    let endProps = {};
    if (endId) {
        endProps.id = endId;
        menuItemProps['aria-describedby'] = [
            menuItemProps['aria-describedby'],
            endId
        ].filter(Boolean).join(' ');
    }
    let contents = typeof rendered === 'string' ? /*#__PURE__*/ (0, $jp9jM$react).createElement((0, $f8cc90fea9436c19$export$5f1af8db9871e1d6), null, rendered) : rendered;
    return /*#__PURE__*/ (0, $jp9jM$react).createElement((0, $jp9jM$FocusRing), {
        focusRingClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($jp9jM$menu_vars_cssmjs))), 'focus-ring')
    }, /*#__PURE__*/ (0, $jp9jM$react).createElement(ElementType, {
        ...menuItemProps,
        ref: ref,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($jp9jM$menu_vars_cssmjs))), 'spectrum-Menu-item', {
            'is-disabled': isDisabled,
            'is-selected': isSelected,
            'is-selectable': isSelectable,
            'is-open': submenuTriggerProps.isOpen
        })
    }, /*#__PURE__*/ (0, $jp9jM$react).createElement((0, $572f9fec526c2697$export$ef2184bd89960b14), {
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($jp9jM$menu_vars_cssmjs))), 'spectrum-Menu-itemGrid')
    }, /*#__PURE__*/ (0, $jp9jM$react).createElement((0, $62024859ff9f1f8a$export$ceb145244332b7a2), null, /*#__PURE__*/ (0, $jp9jM$react).createElement((0, $62024859ff9f1f8a$export$8107b24b91795686), {
        slots: {
            text: {
                UNSAFE_className: (0, ($parcel$interopDefault($jp9jM$menu_vars_cssmjs)))['spectrum-Menu-itemLabel'],
                ...labelProps
            },
            end: {
                UNSAFE_className: (0, ($parcel$interopDefault($jp9jM$menu_vars_cssmjs)))['spectrum-Menu-end'],
                ...endProps
            },
            icon: {
                UNSAFE_className: (0, ($parcel$interopDefault($jp9jM$menu_vars_cssmjs)))['spectrum-Menu-icon'],
                size: 'S'
            },
            description: {
                UNSAFE_className: (0, ($parcel$interopDefault($jp9jM$menu_vars_cssmjs)))['spectrum-Menu-description'],
                ...descriptionProps
            },
            keyboard: {
                UNSAFE_className: (0, ($parcel$interopDefault($jp9jM$menu_vars_cssmjs)))['spectrum-Menu-keyboard'],
                ...keyboardShortcutProps
            },
            chevron: {
                UNSAFE_className: (0, ($parcel$interopDefault($jp9jM$menu_vars_cssmjs)))['spectrum-Menu-chevron'],
                size: 'S'
            }
        }
    }, contents, isSelected && /*#__PURE__*/ (0, $jp9jM$react).createElement((0, $jp9jM$spectrumiconsuiCheckmarkMedium), {
        slot: "checkmark",
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($jp9jM$menu_vars_cssmjs))), 'spectrum-Menu-checkmark')
    }), isUnavailable && /*#__PURE__*/ (0, $jp9jM$react).createElement((0, $jp9jM$spectrumiconsworkflowInfoOutline), {
        slot: "end",
        size: "XS",
        alignSelf: "center",
        "aria-label": stringFormatter.format('unavailable')
    }), isUnavailable == null && isSubmenuTrigger && (direction === 'rtl' ? /*#__PURE__*/ (0, $jp9jM$react).createElement((0, $jp9jM$spectrumiconsworkflowChevronLeft), {
        slot: "chevron"
    }) : /*#__PURE__*/ (0, $jp9jM$react).createElement((0, $jp9jM$spectrumiconsworkflowChevronRight), {
        slot: "chevron"
    })))))));
}


export {$764fca59ff9a0c0a$export$2ce376c2cc3355c8 as MenuItem};
//# sourceMappingURL=MenuItem.mjs.map
